import { motion, AnimatePresence } from 'framer-motion'
import { CheckCircle, XCircle, AlertCircle, Info, X } from 'lucide-react'
import { useEffect } from 'react'

const Toast = ({ message, type = 'success', onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 4000)
    return () => clearTimeout(timer)
  }, [onClose])

  const icons = {
    success: <CheckCircle className="w-6 h-6 text-green-400" />,
    error: <XCircle className="w-6 h-6 text-red-400" />,
    warning: <AlertCircle className="w-6 h-6 text-yellow-400" />,
    info: <Info className="w-6 h-6 text-blue-400" />
  }

  const backgrounds = {
    success: 'bg-green-900/90 border-green-500/50',
    error: 'bg-red-900/90 border-red-500/50',
    warning: 'bg-yellow-900/90 border-yellow-500/50',
    info: 'bg-blue-900/90 border-blue-500/50'
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: -50, scale: 0.9 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: -20, scale: 0.9 }}
      className={`fixed top-4 right-4 z-[9999] flex items-center space-x-3 px-6 py-4 rounded-xl backdrop-blur-xl border ${backgrounds[type]} shadow-2xl max-w-md w-[90vw] md:w-auto`}
    >
      {icons[type]}
      <p className="text-cream font-medium flex-1">{message}</p>
      <button
        onClick={onClose}
        className="text-beige-400 hover:text-cream transition-colors flex-shrink-0"
      >
        <X className="w-5 h-5" />
      </button>
    </motion.div>
  )
}

export default Toast
